import logo from "./logo.svg";
import "./App.css";
import OnBoarding from "./Pages/OnBoarding/OnBoarding";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import Home from "./Pages/Home/Home";
import NftAuction from "./Pages/NftAuction/NftAuction";
import Raise from "./Pages/Raise/Raise";
import Marketplace from "./Pages/Marketplace/Marketplace";
import NftDetails from "./Pages/NftDetails/NftDetails";
import Claims from "./Pages/Claims/Claims";
import ScrollToTop from "./GlobalComponents/ScrollToTop/ScrollToTop";
import Reward from "./Pages/Reward/Reward";
import Explore from "./Pages/Explore/Explore";
import NFTone from './Pages/NFTone/NFTone'
import MyProfile from "./Pages/MyProfile/MyProfile";
import Subscription from "./Pages/Subscription/Subscription";
import Forexs from "./Pages/Forexs/Forexs";
import Portal from "./Pages/Portal/Portal";
import NftSmallDetails from "./Pages/NftSmallDetails/NftDetails";
import React, { createContext } from 'react';
import MyContext from "./MyContext";


// Create a context
const MyProvider = ({ children }) => {
  // Define the global variable state and its update function
  const [login, setLogin] = React.useState([]);

  // Return the provider with the global variable state and update function
  return (
    <MyContext.Provider value={{ login, setLogin }}>
      {children}
    </MyContext.Provider>
  );
};

function App() {
  return (
    <MyProvider>
      <BrowserRouter>
        <ScrollToTop></ScrollToTop>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/on-boarding" element={<OnBoarding />} />
          <Route path="/nft-auction" element={<NftAuction />} />
          <Route path="/raise" element={<Raise />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/nft-details" element={<NftDetails />} />
          <Route path="/nft-small" element={<NftSmallDetails />} />
          <Route path="/claims" element={<Claims />} />
          <Route path="/reward" element={<Reward />} />
          <Route path="/explore" element={<Explore />} />
          <Route path="/NFTone" element={<NFTone />} />
          <Route path="/my-profile" element={<MyProfile />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/forexs" element={<Forexs />} />
          <Route path="/portal" element={<Portal />} />
        </Routes>
      </BrowserRouter>
    </MyProvider>
  );
}

export default App;
